import { connect } from 'react-redux'

import { addRentalReputationBackUrl } from 'app/shared_components/actions'
import { fetchApplication } from 'app/sm/apply/apply_actions'
import {
  acceptJointApplicationAsSecondary,
  submitFinalApplication,
} from 'app/sm/apply/apply_actions'
import {
  addExtraIncome,
  addProofOfIncome,
  deleteProofOfIncome,
  editExtraIncome,
  fetchExtraIncome,
  fetchProofOfIncome,
  saveManualBankStatementRedactions,
} from 'app/sm/proof_of_income/proof_of_income_actions'
import Container from 'app/sm/proof_of_income/proof_of_income_container'
import {
  fetchCompleteness,
  fetchTeamSettingInformation,
} from 'app/sm/rental_reputation/actions'
import { retrieveReputationPreference } from 'app/sm/rental_reputation/actions'

const mapStateToProps = ({
  ProofOfIncome,
  Shared,
  apply,
  RentalReputation,
}) => ({
  documents: ProofOfIncome.documents,
  spinners: ProofOfIncome.spinners,
  responseTexts: ProofOfIncome.responseTexts,
  backUrl: Shared.backUrl,
  property: apply.property,
  completeness: RentalReputation.completeness,
  applicationDetails: apply.application,
  analysisJobID: ProofOfIncome.analysisJobID,
  applyRules: apply.applyRules,
  isQLDForm22: apply.isQLDForm22,
})

const mapDispatchToProps = (dispatch) => ({
  fetchProofOfIncome: () => dispatch(fetchProofOfIncome()),
  addProofOfIncome: (documentType, fileType, agencyGUID) =>
    dispatch(addProofOfIncome(documentType, fileType, agencyGUID)),
  deleteProofOfIncome: (id, fileType, agencyGUID) =>
    dispatch(deleteProofOfIncome(id, fileType, agencyGUID)),
  addRentalReputationBackUrl: (rentalBackUrl) =>
    dispatch(addRentalReputationBackUrl(rentalBackUrl)),
  fetchCompleteness: () => dispatch(fetchCompleteness()),
  addExtraIncome: (extraIncome) => dispatch(addExtraIncome(extraIncome)),
  fetchExtraIncome: () => dispatch(fetchExtraIncome()),
  saveManualBankStatementRedactions: (documentGuid, areas) =>
    dispatch(saveManualBankStatementRedactions(documentGuid, areas)),
  fetchTeamSettingInformation: (id, type) =>
    dispatch(fetchTeamSettingInformation(id, type)),
  editExtraIncome: (referenceId, extraIncome) =>
    dispatch(editExtraIncome(referenceId, extraIncome)),
  retrieveReputationPreference: () => dispatch(retrieveReputationPreference()),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
  submitFinalApplication: (applicationId, data) =>
    dispatch(submitFinalApplication(applicationId, data)),
  acceptJointApplicationAsSecondary: (
    applicationId,
    applicantId,
    applicantSummary,
    apply,
    data,
  ) =>
    dispatch(
      acceptJointApplicationAsSecondary(
        applicationId,
        applicantId,
        applicantSummary,
        apply,
        data,
      ),
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Container)
